var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFillCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 8.60065V11.4007C10.6666 13.734 9.73325 14.6673 7.39992 14.6673H4.59992C2.26659 14.6673 1.33325 13.734 1.33325 11.4007V8.60065C1.33325 6.26732 2.26659 5.33398 4.59992 5.33398H7.39992C9.73325 5.33398 10.6666 6.26732 10.6666 8.60065Z",
    fill: "#9091A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4001 1.33398H8.60009C6.67939 1.33398 5.71176 1.97092 5.42932 3.49325C5.32773 4.04082 5.79508 4.50065 6.35199 4.50065H7.40009C10.2001 4.50065 11.5001 5.80065 11.5001 8.60065V9.64875C11.5001 10.2057 11.9599 10.673 12.5075 10.5714C14.0298 10.289 14.6668 9.32135 14.6668 7.40065V4.60065C14.6668 2.26732 13.7334 1.33398 11.4001 1.33398Z",
    fill: "#9091A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFillCopy);
export default __webpack_public_path__ + "static/media/ic-fill-copy.e647061f7ae9d99063f15afe9f47cf7e.svg";
export { ForwardRef as ReactComponent };